<template>
  <div>
    <p>Almost there !</p>
    <button @click="fixGrid">Remove wrong items</button>
  </div>
</template>

<script>
export default {
  props: {
    artworkVisible: Boolean,
  },
  methods: {
    hide: function() {
      this.$root.$emit("image:hide");
    },
    fixGrid: function() {
      this.$root.$emit("grid:fix");
    },
  },
};
</script>

<style scoped>
button {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  color: #fff;
  background-color: #1976d2;
  padding: 6px 16px;
  font-size: 0.875rem;
  min-width: 64px;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  line-height: 1.75;
  border-radius: 5px;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: rgb(17, 82, 147);
}

button:active {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

@media screen and (min-width: 1000px) {
  .hide {
    opacity: 0;
  }
}
</style>
